(function () {
  const KLAVIYO_REVISION = '2024-10-15';
  const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function init(form) {
    if (form.dataset.klaviyoBound === '1') return;
    form.dataset.klaviyoBound = '1';

    const input = form.querySelector('.klaviyo-signup__input');
    const submit = form.querySelector('.klaviyo-signup__submit');
    const submitLabel = submit.querySelector('.klaviyo-signup__submit-label') || submit;
    const banner = form.querySelector('[data-klaviyo-banner]');

    const companyId = (form.dataset.companyId || '').trim();
    const listId = (form.dataset.listId || '').trim();
    const successMsg = form.dataset.successMsg || '¡Gracias! Te has unido.';
    const errorMsg = form.dataset.errorMsg || 'No hemos podido suscribirte. Inténtalo de nuevo.';
    const invalidMsg = form.dataset.invalidMsg || 'Introduce un email válido.';

    function showBanner(type, text) {
      banner.className = 'klaviyo-signup__banner klaviyo-signup__banner--' + type;
      banner.textContent = text;
      banner.hidden = false;
    }

    function hideBanner() {
      banner.hidden = true;
      banner.textContent = '';
    }

    form.addEventListener('submit', async function (e) {
      e.preventDefault();
      hideBanner();

      const email = (input.value || '').trim();
      if (!EMAIL_RE.test(email)) {
        showBanner('error', invalidMsg);
        input.focus();
        return;
      }

      if (!companyId || !listId) {
        // eslint-disable-next-line no-console
        console.error('[klaviyo-signup] Faltan ajustes: company_id o list_id en el tema.');
        showBanner('error', errorMsg);
        return;
      }

      form.classList.add('is-loading');
      submit.disabled = true;
      const originalLabel = submitLabel.textContent;
      submitLabel.textContent = '…';

      try {
        const url =
          'https://a.klaviyo.com/client/subscriptions/?company_id=' +
          encodeURIComponent(companyId);

        const payload = {
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'Shopify – ' + (document.title || 'web'),
              profile: {
                data: {
                  type: 'profile',
                  attributes: { email: email },
                },
              },
            },
            relationships: {
              list: { data: { type: 'list', id: listId } },
            },
          },
        };

        const res = await fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            revision: KLAVIYO_REVISION,
          },
          body: JSON.stringify(payload),
        });

        if (res.status === 202 || res.ok) {
          showBanner('success', successMsg);
          form.reset();
        } else {
          let detail = '';
          try {
            const json = await res.json();
            detail = (json.errors && json.errors[0] && json.errors[0].detail) || '';
          } catch (_) {}
          // eslint-disable-next-line no-console
          console.warn('[klaviyo-signup] error', res.status, detail);
          showBanner('error', detail || errorMsg);
        }
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error('[klaviyo-signup] network error', err);
        showBanner('error', errorMsg);
      } finally {
        form.classList.remove('is-loading');
        submit.disabled = false;
        submitLabel.textContent = originalLabel;
      }
    });
  }

  function boot() {
    document.querySelectorAll('[data-klaviyo-form]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-init en eventos del theme editor (Shopify customizer)
  document.addEventListener('shopify:section:load', boot);
})();
